import React from 'react';

import PropTypes from 'prop-types';

export const ExpertTableInfoText = ({
  showInfoText,
  hasEnergy,
  hasGas,
  errors = [],
  errorTypes = [],
  primaryErrorClass = 'deb-form__error-text',
  secondaryErrorClass = 'deb-form__error-text',
  expertLabel = 'Fachkraft',
}) => {
  if (!showInfoText) {
    return null;
  }

  const shouldShowPrimaryError =
    errors.length === 0 || errors.some((error) => errorTypes.includes(error));
  const shouldShowSecondaryError =
    errors.length === 0 || errors.some((error) => errorTypes.slice(-1).includes(error));

  const primaryErrorClassName = shouldShowPrimaryError ? primaryErrorClass : '';
  const secondaryErrorClassName = shouldShowSecondaryError ? secondaryErrorClass : '';

  if (hasEnergy && hasGas) {
    return (
      <>
        <div className={primaryErrorClassName}>
          Bitte fügen Sie mindestens eine {expertLabel} pro Sparte hinzu.
        </div>
        <div className={secondaryErrorClassName}>
          (z.B. Herr Muster für die Sparten Gas und Strom oder {expertLabel} 1 für Strom und{' '}
          {expertLabel} 2 für Gas)
        </div>
      </>
    );
  }

  return (
    <div className={primaryErrorClassName}>
      Bitte fügen Sie mindestens eine {expertLabel} hinzu.
    </div>
  );
};

ExpertTableInfoText.propTypes = {
  showInfoText: PropTypes.bool.isRequired,
  hasEnergy: PropTypes.bool.isRequired,
  hasGas: PropTypes.bool.isRequired,
  errors: PropTypes.array,
  errorTypes: PropTypes.array,
  primaryErrorClass: PropTypes.string,
  secondaryErrorClass: PropTypes.string,
  expertLabel: PropTypes.string,
};

ExpertTableInfoText.defaultProps = {
  errors: [],
  errorTypes: [],
  primaryErrorClass: 'deb-form__error-text',
  secondaryErrorClass: 'deb-form__error-text',
  expertLabel: 'Fachkraft',
};
